import { useInfiniteQuery } from 'react-query';
import { ApiCollectionResponse } from 'types/api_response';
import { baseApiUrl, fetcher } from 'data_sources/constants';
import { ServerErrorResponse } from 'data_sources/constants';
import { DTBReportResult } from 'views/App/Portal/Reporting/DTBs/_types/dtbs';

export default function usePolicyAcknowledgmentReport<T extends DTBReportResult>(
  orgId: string,
  params: Record<string, any> = {},
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexiverse/reports/v1/organizations/${orgId}/reports/dtbs/full-audit`;
  return useInfiniteQuery<ApiCollectionResponse<T>, Error>(
    ['reporting_dtbs', orgId, params],
    async ({ pageParam, signal }): Promise<ApiCollectionResponse<T>> => {
      const paramString = new URLSearchParams(
        Object.entries({
          ...params,
          ...(pageParam && { nextToken: pageParam }),
        })
          .filter(([_k, v]) => v != null)
          .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
      ).toString();
      const data: ApiCollectionResponse<T> = await fetcher({
        method: 'get',
        url: `${url}?${paramString}`,
        options: { signal },
      }).catch((err) => {
        if (onError) onError(err);
        throw err;
      });

      return data;
    },
    {
      getNextPageParam: (lastPage) => {
        if (
          lastPage?.offset != null &&
          lastPage?.count != null &&
          lastPage.offset < lastPage.count &&
          Array.isArray(lastPage.content) &&
          lastPage.content.length > 0
        ) {
          return lastPage.offset;
        }
        return undefined;
      },
      ...options,
    }
  );
}
